import { Check, Info } from 'lucide-react';
import { AFTER_CARE_NOTES, PREPARATION_NOTES } from '../constants';

interface VisitNotesSectionProps {
  /** True when the appointment is completed (show after-care). False = upcoming (show prep). */
  isCompleted: boolean;
}

export const VisitNotesSection = ({ isCompleted }: VisitNotesSectionProps) => {
  const items = isCompleted ? AFTER_CARE_NOTES : PREPARATION_NOTES;
  const heading = isCompleted ? 'After-Care Instructions' : 'How to Prepare for Your Visit';

  return (
    <div className="bg-white border border-gray-200 rounded-xl p-5">
      <div className="flex items-center gap-2 mb-4">
        <Info size={15} className="text-teamcare-blue" />
        <h3 className="text-sm font-bold text-secondary-900">{heading}</h3>
      </div>
      <div className="grid grid-cols-1 sm:grid-cols-2 gap-x-6 gap-y-4">
        {items.map(({ title, description }) => (
          <div key={title} className="flex items-start gap-3">
            <div className="w-5 h-5 rounded-full bg-teamcare-blue flex items-center justify-center shrink-0 mt-0.5">
              <Check size={12} strokeWidth={3} className="text-white" />
            </div>
            <div>
              <p className="text-sm font-bold text-secondary-900">{title}</p>
              <p className="text-xs text-secondary-500 mt-0.5 leading-relaxed">
                {description}
              </p>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};
